import { Button, Card, Form, Input, message } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import "../styles/index.css";
import { useState, useEffect, useRef } from "react";
import BillCard from "./BillPage";
import { AndhraApiService } from "../httpsservice/ApiService";

const ServicePage = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [error, setError] = useState("");
  const [showBill, setShowBill] = useState(false);
  const [billData, setBillData] = useState(null);
  const [form] = Form.useForm();

  const [captchaSize, setCaptchaSize] = useState("normal");
  const recaptchaRef = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [isFetchLoading, setFetchLoading] = useState(false);

  useEffect(() => {
    const updateCaptchaSize = () => {
      if (window.innerWidth < 400) {
        setCaptchaSize("compact");
      } else {
        setCaptchaSize("normal");
      }
    };

    updateCaptchaSize(); // Initial call
    window.addEventListener("resize", updateCaptchaSize);

    return () => window.removeEventListener("resize", updateCaptchaSize);
  }, []);

  useEffect(() => {}, [showBill, billData]); // Logs state updates properly

  const handleSubmit = async () => {
    if (!captchaToken) {
      setError("Please complete the CAPTCHA.");
      return;
    }

    setError(""); // Clear previous errors

    try {
      await callServiceNumberApi();
    } catch (err) {
      console.error("API call error:", err);
    }
    recaptchaRef.current.reset();
    setCaptchaToken(null);
  };

  const callServiceNumberApi = async () => {
    setFetchLoading(true);
    const serviceNumber = form.getFieldValue("service_number");

    if (!serviceNumber) {
      setError("Please enter a service number.");
      setFetchLoading(false);
      return;
    }

    const queryData = {
      service_number: serviceNumber,
      captcha: captchaToken,
    };

    try {
      const response = await AndhraApiService.getBillDetails(queryData);

      if (response?.data && response.success) {
        setBillData(response.data);
        setShowBill(true);
      } else {
        setShowBill(false);
        setBillData(null);
        messageApi.error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      messageApi.error("Could not fetch data!");
      setShowBill(false);
      setBillData(null);
    }
    setFetchLoading(false);
  };

  return (
    <>
      {contextHolder}
      <div className="main-wrapper-andhra-pradesh">
        <div className="center-container">
          <div className="center-box-bill">
            {!showBill && !billData && (
              <Card
                className="service-number-card"
                cover={
                  <div className="logo-main">
                    <img
                      alt="BSES"
                      className="bses-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/cpdcl_logo.svg"
                    />
                    <img
                      alt="Another Image"
                      className="bob-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/Federal_bank.svg"
                    />
                  </div>
                }
              >
                <Form form={form} onFinish={handleSubmit}>
                  <span className="service-number-input">Service number</span>
                  <Form.Item
                    name="service_number"
                    rules={[
                      { required: true, message: "Invalid service number" },
                    ]}
                  >
                    <Input
                      className="service-number-input"
                      maxLength={13}
                      placeholder="Enter Service Number"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 13) {
                          form.setFieldsValue({ service_number: value });
                        }
                      }}
                    />
                  </Form.Item>
                  <span className="service-number-captcha">Captcha</span>
                  <Form.Item>
                    <div className="recaptcha-container">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                        size={captchaSize}
                        onChange={(token) => {
                          setCaptchaToken(token);
                          setError(""); // Clear error when CAPTCHA is completed
                        }}
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="fetch-bill-btn"
                      size="large"
                      block
                      htmlType="submit"
                      loading={isFetchLoading}
                    >
                      Fetch Bill
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
            {showBill && billData && <BillCard billData={billData} />}
            <div className="poweredby-logo-main">
              <img
                alt="poweredby-logo"
                className="poweredby-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicePage;
